export default {};


// WEBPACK FOOTER //
// ./src/components/GlobalVariables.js